// Тема оформления: тёмная по умолчанию, светлая — по выбору пользователя (переключатель в сайдбаре).
// До загрузки приложения тему ставит public/theme.js (тот же ключ и правило), чтобы не было вспышки.

export type Theme = 'dark' | 'light';
export const THEME_KEY = 'labconnect.theme';

function stored(): Theme {
  try {
    return localStorage.getItem(THEME_KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export const currentTheme = (): Theme =>
  document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';

export function applyStoredTheme(): void {
  document.documentElement.dataset.theme = stored();
}

export function setTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    // Хранилище недоступно (приватный режим) — тема действует до перезагрузки
  }
}
